import React from "react";

import { Carousel, Image } from "react-bootstrap";
import ProductSlider from "./common/ProductSlider";

const Slider = () => {
  return (
    <Carousel className="mt-5">
      {ProductSlider.map((productImg, index) => (
        <Carousel.Item interval={2000} key={index}>
          <Image
            className="d-block w-100"
            src={productImg.product_img}
            height="400px"
            style={{
              border: "1px solid black",
            }}
            alt={productImg.img_name}
          />
        </Carousel.Item>
      ))}
    </Carousel>
  );
};

export default Slider;
